import { memo } from "react";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const UBOIdentityVerificationLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.Merchant].UBOIdentityVerification}`}
        Icon={PermIdentityIcon}
        {...props}
    >
        UBO Identity Verification
    </StepLabel>
);

export default memo(UBOIdentityVerificationLabel);
